// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"dY-z","carousel":"eY-z"};